import { instance } from "../instance";

/**
 * GET Analytics Incident List
 * @param facilityId
 * @param incidentTypes
 * @param startDate
 * @param endDate
 * @returns []
 */
export const getAnalyticsIncidentList = async (
  facilityIds: any,
  incidentTypes: any,
  startDate: string,
  endDate: string
) => {
  return instance({
    method: "GET",
    url: `/analytic/list?startDate=${startDate}&endDate=${endDate}&facilityIds=${facilityIds}&incidentTypes=${incidentTypes}`,
  });
};

export const incidentRateAnalysis = async (
  facilityIds: any,
  startDate: string,
  endDate: string,
  incidentTypes: string,
  residentStatus: string[]
) => {
  return instance({
    method: "GET",
    url: `/analytic/incidentsrate?startDate=${startDate}&endDate=${endDate}&facilityIds=${facilityIds}&incidentTypes=${incidentTypes}&residentStatus=${residentStatus.join(";")}`,
  });
};

/**
 * GET Analytics Status Report
 * @param facilityId
 * @param startDate
 * @param endDate
 * @returns []
 */
export const getAnalyticsStatusReport = async (
  facilityIds: any,
  startDate: string,
  endDate: string
) => {
  return instance({
    method: "GET",
    url: `/analytic/list?startDate=${startDate}&endDate=${endDate}&facilityIds=${facilityIds}`, // if not incidentTypes, it will return all incidents
  });
};

/**
 * GET Analytics Incident Trend
 * @param facilityId
 * @param startDate
 * @param endDate
 * @returns []
 */
export const getAnalyticsIncidentTrend = async (
  facilityIds: any,
  startDate: string,
  endDate: string,
  incidentTypes: string,
  grouping: string
) => {
  return instance({
    method: "get",
    url: `/analytic/trend?startDate=${startDate}&endDate=${endDate}&facility=${facilityIds}&incidentTypes=${incidentTypes}&grouping=${grouping}`,
  });
};

/**
 * GET Analytics Repeat Incident
 * @param facilityId
 * @param startDate
 * @param endDate
 * @param incidentTypes
 * @param residentStatus
 * @returns []
 */
export const getAnalyticsRepeatIncidents = async (
  facilityIds: any,
  startDate: string,
  endDate: string,
  incidentTypes: string,
  residentStatus: string[]
) => {
  return instance({
    method: "GET",
    url: `/analytic/repeat/incident?startDate=${startDate}&endDate=${endDate}&facilityIds=${facilityIds}&incidentTypes=${incidentTypes}&residentStatus=${residentStatus.join(";")}`,
  });
};

/**
 * GET Analytics Wound Analysis
 * @param facilityIds
 * @param startDate
 * @param endDate
 * @param skinIssueTypes
 * @returns []
 */
export const getAnalyticsWoundAnalysis = async (
  facilityIds: any,
  startDate: string,
  endDate: string,
  skinIssueTypes: string[]
) => {
  return instance({
    method: "GET",
    url: `/analytic/wound-analysis?startDate=${startDate}&endDate=${endDate}&facilityIds=${facilityIds}&skinIssueTypes=${skinIssueTypes}`,
  });
};

/**
 * GET Analytics Behavior Analysis Report
 * @param facilityIds
 * @param startDate
 * @param endDate
 * @param behaviorIncidentTypes
 * @param behaviorIncidentSubTypes
 */
export const getAnalyticsBehaviorAnalysis = async (
facilityIds: string[], startDate: string, endDate: string, behaviorIncidentTypes: string[], behaviorIncidentSubTypes: string[]) => {
  return instance({
    method: "GET",
    url: `/analytic/behavior-analysis?startDate=${startDate}&endDate=${endDate}&facilityId=${facilityIds}&incidentTypes=${behaviorIncidentTypes}&incidentSubTypes=${behaviorIncidentSubTypes}`,
  });
};

/**
 * GET Analytics Injury Report
 * @param facilityIds
 * @param startDate
 * @param endDate
 * @param incidentTypes
 * @param injuryTypes
 * @returns []
 */
export const getAnalyticsInjuryReport = async (
  facilityIds: any,
  startDate: string,
  endDate: string,
  incidentTypes: string,
  injuryTypes: string
) => {
  return instance({
    method: "GET",
    url: `/analytic/injury-report?startDate=${startDate}&endDate=${endDate}&facilityIds=${facilityIds}&incidentTypes=${incidentTypes}&injuryTypes=${injuryTypes}`,
  });
};

/**
 * GET Injury Types
 * @returns []
 */
export const getInjuryTypes = async () => {
  return instance({
    method: "GET",
    url: `/incident/injury-types`,
  });
};

// new fall analysis
export const incidentListAnalysis = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/analytic/list?startDate=${startDate}&endDate=${endDate}&facilityIds=${facility}&incidentTypes=Fall`,
  });
};

export const repeatFallAnalysis = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/analytic/repeat/incident?startDate=${startDate}&endDate=${endDate}&facilityIds=${facility}&incidentTypes=Fall`,
  });
};

export const actualVsProjectedFall = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/projectedfall?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
    apiVersion: "v2",
  });
};

export const fallIncidentPlace = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallincidentplace?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
  });
};

export const activityPriorIncident = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallresidentaction/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
  });
};

export const careGiversReportingIncidents = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallincidentcreatedby/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
  });
};

export const overviewRepeatfallsIncidents = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallrepeatanalytics/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
  });
};

// Caregiver Audit (MARCC-773): all incident types (optionally filtered), four
// caregiver roles (optionally filtered to specific caregivers).
export const caregiverAuditOverview = async (
  facility: any,
  startDate: any,
  endDate: any,
  incidentTypes: any = "",
  caregiverIds: any = ""
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/caregiveraudit/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentTypes=${encodeURIComponent(
      incidentTypes ?? ""
    )}&caregiverIds=${encodeURIComponent(caregiverIds ?? "")}`,
  });
};

export const caregiverAuditDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  caregiverId: any,
  caregiverName: any,
  incidentTypes: any = ""
) => {
  // Match by caregiverId; caregiverName kept as a fallback (compound Name isn't
  // filterable when Middle Name is enabled).
  return instance({
    method: "GET",
    url: `/advanceanalytic/caregiverauditdetail/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&caregiverId=${encodeURIComponent(
      caregiverId ?? ""
    )}&caregiverName=${encodeURIComponent(
      caregiverName ?? ""
    )}&incidentTypes=${encodeURIComponent(incidentTypes ?? "")}`,
  });
};

export const overviewDayOfWeekFallIncidentAnalytis = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/daysoftheweek/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
  });
};

export const overviewOfShiftAndUnitFallIncidents = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallanalyticsshiftunit/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
  });
};

export const overviewTimeOfIncident2HourSpans = async (
  facility: any,
  startDate: any,
  endDate: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallanalyticstimeofincident/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`,
  });
};

// inner pages
export const daysOfWeekDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  day: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/daysoftheweekdetail/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall&day=${day}`,
  });
};

export const placeOfIncidentDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  place: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallincidentplacedetail/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall&place=${place}`,
  });
};

export const activityPriorDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  residentAction: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallresidentactiondetail/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall&residentAction=${residentAction}`,
  });
};

export const caregiversReportingDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  createdById: any,
  createdBy: any
) => {
  // Match by createdById; createdBy (name) kept for backward-compat (compound
  // Name isn't filterable when Middle Name is enabled).
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallincidentcreatedbydetail/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall&createdById=${encodeURIComponent(
      createdById ?? ""
    )}&createdBy=${encodeURIComponent(createdBy ?? "")}`,
  });
};

export const repeatFallDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  residentId: any,
  residentName: any
) => {
  // Match by residentId; residentName kept for backward-compat (compound Name
  // isn't filterable when Middle Name is enabled).
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallrepeatdetails/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall&residentId=${encodeURIComponent(
      residentId ?? ""
    )}&residentName=${encodeURIComponent(residentName ?? "")}`,
  });
};

export const timeOfIncidentDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  shift: any
) => {
  return instance({
    method: "GET",
    url: `/advanceanalytic/fallanalyticstimeofincidentdetail/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall&shift=${shift}`,
  });
};

export const shiftAndUnitDetails = async (
  facility: any,
  startDate: any,
  endDate: any,
  shift: any,
  unit: any
) => {
  let url = `/advanceanalytic/fallanalyticsshiftunitdetail/?startDate=${startDate}&endDate=${endDate}&facilityId=${facility}&incidentType=Fall`;
  if (shift?.length) url = `${url}&shift=${shift}`;
  if (unit.length) url = `${url}&unit=${unit}`;

  return instance({
    method: "GET",
    url: url,
  });
};

export const actualVsProjectedDetails = async (
  facility: string,
  monthStart: string,
  monthEnd: string,
  label: string
) => {
  let url: string | null = null;
  switch (label) {
    case "injuryByMonth":
      url = `/advanceanalytic/projectedinjuryincident/?startDate=${monthStart}&endDate=${monthEnd}&facilityId=${facility}&incidentType=Fall`;
      break;
    case "transferToHospitalByMonth":
      url = `/advanceanalytic/projectedhospitalincident/?startDate=${monthStart}&endDate=${monthEnd}&facilityId=${facility}&incidentType=Fall`;
      break;
    case "fallByMonth":
      url = `/advanceanalytic/projectedfallincident/?startDate=${monthStart}&endDate=${monthEnd}&facilityId=${facility}&incidentType=Fall`;
      break;
    default:
      throw new Error(`Unknown label: ${label}`);
  }
  return instance({
    method: "GET",
    url: url,
  });
};
